import $ from 'jquery';

function TopMenu(element) {
  this.$element = $(element);
  this.init();
}

TopMenu.prototype = {
  init() {
    let $classes = this.$element.find('a').attr('class');
    $classes = $classes.split(' ');

    $classes.forEach((value) => {
      if (value.substring(0, 4) === 'tid-') {
        const $leftNav = $(document.getElementById('block-menu_block-2'));
        const tid = value.split('-');
        if ($(document.body).is(`.tt${tid[1]}`)) {
          $leftNav.addClass('hide-title');
        }
      }
    });
  },
};

export default TopMenu;



// WEBPACK FOOTER //
// ./TopMenu.js